import { Role } from '../types';
import api from '../api';

export default {
  findAll(accountType: number, serviceId: string|null, assignable?: boolean): Promise<Role[]> {
    return api
      .get(`account-types/${accountType}/roles`, { params: { serviceId, assignable } })
      .then(response => response.data);
  },
};
